import styled from "styled-components";
import { colours } from "../../../../../../styles/colours.constants";
import { satoshi700 } from "../../../../../../styles/font.constants";

export const TeamList = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Seperator = styled.div`
	${satoshi700}
	font-size: 1rem;
	color: ${colours.black};
	margin: 1rem 0;
`;
